<template>
  <div>
  <Modal :mask-closable="false" title="新增课前预习" v-model="visible" width="1000px" @on-ok="saveData">
    <Form ref="previewForm" class="form"
          :model="formData" :rules="previewRule"
          :label-width="80">
      <Row>
        <Col :span="6">
        <Form-item label="教材版本" prop="version">
          <Select :transfer="true" v-model.number="formData.version" clearable @on-change="onVersionChange">
            <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="选择开始Level" prop="levelId" :label-width="100">
          <Select :transfer="true" v-model="formData.levelId" clearable filterable @on-change="onLevelChange">
            <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="6">
        <Form-item label="选择对应课程" :label-width="100">
          <Select :transfer="true" v-model="formData.lessonId" clearable filterable>
            <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="8">
        <Form-item label="标题" prop="title">
          <Input v-model="formData.title"/>
        </Form-item>
        </Col>
        <Col :span="5">
        <Form-item label="状态" prop="status">
          <Select :transfer="true" v-model.number="formData.status" clearable>
          <Option value="-1">禁用</Option>
          <Option value="0">未启用</Option>
          <Option value="1">启用</Option>
          <Option value="2">预览</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <quillEditor v-model="formData.content" ref="myQuillEditor" :options="editorOption" @change="textChange"></quillEditor>
    <el-upload class="upload-demo" :action="action" :before-upload='beforeUpload'
               :headers="headers" :accept="acceptType" :on-success='upScuccess' ref="upload" style="display:none">
      <el-button size="small" type="primary" id="imgInput" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="插入中,请稍候">点击上传</el-button>
    </el-upload>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" @click="openPreview">预览</Button>
      <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
  import LessonPreviewModal from './LessonPreview'
  import * as Quill from 'quill'
  import { quillEditor } from 'vue-quill-editor'

  var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
  var Font = Quill.import('formats/font')
  Font.whitelist = fonts
  Quill.register(Font, true)

  export default {
    components: {
      LessonPreviewModal,
      quillEditor,
    },
    name: 'LessonPreviewInsertModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      lessonId: {
        type: Number,
        default: null
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        id: null,
        levels: [],
        lessons: [],
        headers: {},
        uploadType: '',
        loadingInsert: false,
        fullscreenLoading: false,
        action: this.$appConfig.baseUrl + '/upload/fileUpload',
        acceptType: '',
        formData: {
          content: '',
          title: '',
          lessonId: null,
          status: '',
          version: null,
          levelId: '',
        },
        options: {
        },
        visible: this.value,
        insertUserParam: {
          regType: '',
        },
        previewRule: {
          title: [
            { type: 'string', required: true, message: '标题不能为空', trigger: 'blur' },
          ],
          version: [
            { type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }
          ],
          content: [
            { type: 'string', required: true, message: '内容不能为空', trigger: 'blur' },
          ],
          levelId: [
            { type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }
          ],
          status: [
            { type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }
          ],
        },
        editorOption: {
          modules: {
            toolbar: {
              container: [
                ['bold', 'italic', 'underline', 'strike'],
                ['blockquote', 'code-block'],
                [{'header': 1}, {'header': 2}],
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'indent': '-1'}, {'indent': '+1'}],
                [{'size': ['small', false, 'large', 'huge']}],
                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                [{'color': []}, {'background': []}],
                [{'align': []}],
                [{ 'font': fonts }],
                ['clean'],
                ['link', 'image', 'video']
              ],
            },
          }
        }
      }
    },
    methods: {
      textChange (val) {
        localStorage.setItem('preview', this.formData.content)
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
      },
      beforeUpload (file) {
        if (file) {
          let names = file.name.split('.')
          if (names.length > 0 && names[names.length - 1] === 'mp3') {
            this.uploadType = 'audio'
          }
        }
        this.fullscreenLoading = true
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }
      },
      // 点击图片ICON触发事件
      imgHandler (state) {
        this.uploadType = 'image'
        this.addRange = this.$refs.myQuillEditor.quill.getSelection()
        if (state) {
          let fileInput = document.getElementById('imgInput')
          fileInput.click() // 加一个触发事件
        }
      },
      // 点击视频ICON触发事件
      videoHandler (state) {
        this.uploadType = 'video'
        this.addRange = this.$refs.myQuillEditor.quill.getSelection()
        if (state) {
          let fileInput = document.getElementById('imgInput')
          fileInput.click() // 加一个触发事件
        }
      },
      // 图片上传成功回调   插入到编辑器中
      upScuccess (e, file, fileList) {
        let self = this
        let response = file.response.data
        if (!response || !response.url) {
          this.$Message.error(`${self.uploadType}插入失败`)
          this.fullscreenLoading = false
          return
        }
        let url = response.url
        if (url != null && url.length > 0) {  // 将文件上传后的URL地址插入到编辑器文本中
          self.addRange = self.$refs.myQuillEditor.quill.getSelection()
          let index = self.addRange != null ? self.addRange.index : 0
          self.$refs.myQuillEditor.quill.insertEmbed(index, self.uploadType, url, 'user') // 调用编辑器的 insertEmbed 方法，插入URL
          this.fullscreenLoading = false
        } else {
          this.$Message.error(`${self.uploadType}插入失败`)
          this.fullscreenLoading = false
        }
        self.uploadType = ''
        this.$refs['upload'].clearFiles()
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
      },
      openPreview () {
        let url = '/#/course/lessonPreview'
        window.open(url)
      },
      saveData () {
        let self = this
        self.loadingInsert = true
        self.$refs.previewForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsert = false
            return
          }
          self.$http.post('/lessonPreview/insert', this.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('新增成功!')
              self.loadingInsert = false
              self.visible = false
              self.successCallback()
            }
          }).catch(function (e) {
            self.loadingInsert = false
          })
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.levels = []
        this.lessons = []
        this.formData = {
          content: '',
          title: '',
          lessonId: null,
          status: '',
          version: null,
          levelId: '',
        }
        if (!val) {
          localStorage.removeItem('preview')
          this.$emit('on-close', val)
        }
      },
      lessonId (val) {
        if (val) {
          this.id = val
        }
      }
    },
    mounted () {
      // 为图片ICON绑定事件  getModule 为编辑器的内部属性
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imgHandler)
      this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('video', this.videoHandler)  // 为视频ICON绑定事件
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// LessonPreviewInsertModal.vue?0757940c